import React, { useState } from 'react';
import {
  CButton, CModal, CModalBody, CModalFooter, CModalHeader,
} from '@coreui/react';
import PropTypes from 'prop-types';

import AddressSearch from '../../../Shared/AddressSearch';

const propTypes = {
  show: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

const StartLocationModal = ({
  show, onClose, onConfirm,
}) => {
  const [address, setAddress] = useState({ street: '', lat: '', lng: '' });

  const onAddressSelect = (addressInfo) => {
    setAddress({
      street: `${addressInfo.street_number || ''}${
        addressInfo.route ? ` ${addressInfo.route}` : ''
      }`,
      lat: addressInfo.lat,
      lng: addressInfo.lng,
    });
  };

  const onAddressChange = (val) => setAddress({ ...address, street: val });

  return (
    <CModal show={show} onClose={onClose}>
      <CModalHeader closeButton>
        <h4 className="mb-0">Enter in the start location</h4>
      </CModalHeader>
      <CModalBody>
        <AddressSearch
          type="text"
          label="Start Location"
          placeholder="Address"
          value={address.street}
          onSelect={onAddressSelect}
          onChange={onAddressChange}
        />
      </CModalBody>
      <CModalFooter>
        <CButton color="primary" onClick={() => onConfirm(address)} disabled={!address.lat}>
          Generate Route
        </CButton>
        {' '}
        <CButton
          color="secondary"
          onClick={onClose}
        >
          Cancel
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

StartLocationModal.propTypes = propTypes;

export default StartLocationModal;
